import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../../../hooks'
import { postMockApplicantMatchReevaluate } from '../../../../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../../../../RentalPortalApplicantProfile.hooks'

export function useApplicantFitCheckReevaluate() {
  const { t } = useTranslation()

  const { handleAddErrorNotification } = useNotification()

  const { applicantId, handleEntityReload } = useApplicantProfileContext()

  const [isReevaluating, setReevaluating] = useState(false)

  async function handleReevaluate() {
    setReevaluating(true)

    try {
      await postMockApplicantMatchReevaluate({ applicantId })

      await handleEntityReload()
    } catch {
      handleAddErrorNotification({
        textButtonValue: t('RentalPortal.ListingRetryBtnKey'),
        title: t('RentalPortal.MatchReevaluateErrorKey'),
        onClickTextButton: handleReevaluate,
      })
    } finally {
      setReevaluating(false)
    }
  }

  return { handleReevaluate, isReevaluating }
}
